import API from 'shared/constants/api';
import { getPrice } from 'shared/helpers/advert';
import { execPostRequest, getCapacity } from './utils';
import { getFinupVerification } from './myAuto';
import { fetchUsersTemperature } from './finup';

export const getUlf24LeasingParms = advert => {
  const { ulf_data: ulf } = advert;
  return (ulf && ulf.calcInfo) || null;
};

export const addUlf24Lead = async (params, fetch) => {
  const {
    advert,
    userName,
    price,
    term,
    phone,
    prepaid,
    comment,
    temperature,
    popularity,
    liquidityDays,
    commentWithAddData,
    userStorageId,
    type,
  } = params;

  const data = {
    type,
    vehicle: {
      // manufacturerId: 1, // Необязательный ID марки авто в справочниках AutoRia
      // modelId: 1, // Необязательный ID марки авто в справочниках AutoRia
      manufacturedYear: advert.year, // Необязательный год выпуска
      engineVolume: getCapacity(advert), // Необязательный объем двигателя в см₃
      // bodyId: 1, // Необязательный ID типа кузова в справочниках AutoRia
      // fuelTypeId: 1, // Необязательный ID типа топлива в справочниках AutoRia
      // transmissionTypeId: 1, // Необязательный ID типа трансмисии в справочниках AutoRia
    },
    contact: {
      name: userName,
      // surname: 'Иванов',
      // inn: '1234567890',
      phoneNumber: phone,
    },
    productFrontId: 249, // Вид лизинга
    period: term, // Срок лизинга
    amount: price, // Стоимость авто, грн
    prepayment: prepaid, // Предоплата, грн
    comment,
    utm_source: 'partner',
    utm_medium: 'avtobazar',
    // utm_campaign: 'utm_campaign ', // Необязательный utm-метка
    // utm_term: 'utm_term ', // Необязательный utm-метка
    // utm_content: 'utm_content' // Необязательный utm-метка

    UF_CRM_1639391109039: temperature || 0, // Температура (вероятность покупки)
    UF_CRM_1639391200032: popularity || 0, // Популярность
    UF_CRM_1639391221982: liquidityDays || 0, // Ликвидность (дней)
    UF_CRM_1639391239836: prepaid, // Рекомендованный аванс %
    UF_CRM_1639391264973: commentWithAddData, // Комментарий
    UF_CRM_1639391283416: userStorageId, // device id
    // UF_CRM_1639391301711: '', // Результат скоринга
  };
  console.log('Create ULF24 Lead');
  return execPostRequest(API.ADVERT.LEASING_ULF24.ADD_LEAD, data, fetch, {}, 'addlead');
};

export const monthlyHapaiCalculate = (carPrice, prepaid, term) =>
  typeof window !== 'undefined' && window.getAnnual ? window.getAnnual(carPrice, prepaid, term) : 0;

export const createHapaiLead = async (params, fetch) => {
  let result = null;
  try {
    const { userStorageId, advert } = params;

    const { popularity, liquidityDays, comment, id: verifyParamsId } = await getFinupVerification(
      advert,
      fetch,
    );
    const temperature = await fetchUsersTemperature(userStorageId, fetch);

    const finupVerificationUrl = 'https://api.finup.lv/view/verification';

    const commentWithAddData = [
      `https://avtobazar.ua${advert.permalink}`,
      `${finupVerificationUrl}/${verifyParamsId}`,
      `https://api.finup.lv/view/profile/${userStorageId}`,
    ].join('\n');

    const hapaiParams = {
      ...params,
      comment,
      popularity,
      liquidityDays,
      commentWithAddData,
      temperature,
      type: 'hapai',
    };
    result = await addUlf24Lead(hapaiParams, fetch);
    if (!result || !result.success) throw Error(`createHapaiLead error ${JSON.stringify(result)}`);
  } catch (e) {
    console.error(e.message);
  }
  return result;
};

export const createUlf24Lead = async (params, fetch) => {
  let result = null;
  try {
    const comment = `https://avtobazar.ua${params.advert.permalink}`;
    const ulfParams = {
      ...params,
      comment,
      commentWithAddData: '',
      temperature: '',
      type: 'ulf24',
    };
    result = await addUlf24Lead(ulfParams, fetch);
    if (!result || !result.id) throw Error('createUlf24Lead error');
  } catch (e) {
    console.error(e.message);
  }
  return result;
};

export const getCalcualations = async (advert, leasing, fetch) => {
  if (!advert || !advert.make) {
    console.error('get Leasing by Advert failled');
    return {};
  }
  let result = {};
  const costUAH = getPrice(advert.price, ['uah']);
  try {
    const data = {
      category: '_ЛЕГКОВЫЕ',
      subcategory: 'ЛЕГКОВЫЕ',
      brand: advert.make.title,
      model: advert.model.title,
      year: advert.year,
      volume: getCapacity(advert),
      cnt: 1,
      cost: `${costUAH}`,
      prepayment: `${leasing.prepayment}`,
      term: leasing.term,
      ccy: 'UAH',
      repayment: 'КЛАССИКА',
      franchise: 0,
      customer: 'ЮЛ',
      format: 1,
      url: `https://avtobazar.ua${advert.permalink}`,
    };

    result = await execPostRequest(API.ADVERT.LEASING_ULF24.CALCULATE, data, fetch);
  } catch (e) {
    result = { error: e.message, serviceInfo: { errorCode: 1, errorMessage: e.message } };
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/shared/helpers/leasing/ulf24.js